import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { HeaderModule } from '../../shared/header/header.module';
import { FormloginModule } from '../../shared/formlogin/formlogin.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { RightShotComponent } from './right-shot/right-shot.component';

import {MatNativeDateModule, MAT_DATE_LOCALE} from '@angular/material/core';

@NgModule({
  declarations: [
    LoginComponent,
    RightShotComponent
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,
    HeaderModule,
    FormloginModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    MatNativeDateModule,
    MatDatepickerModule
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
  ]
}
)

export class LoginModule {

}